import React from "react";
import "../styles/Policies.css";

function Authenticity() {
  return (
    <div className="authenticity-page">
      <div className="authenticity">
        <div className="authori">
          <p>
            At Sankalpveda Natural Pvt. Ltd. (formerly Sankalpveda Natural Pvt.
            Ltd), we deeply value your trust and well-being. As the original
            manufacturers of all our nutraceutical products, approved by the
            Ministry of AYUSH, we are committed to delivering only the highest
            quality supplements to you.
          </p>

          <br />

          <p>
            Unfortunately, there have been instances of counterfeit products
            being sold under our name, which can compromise your health and
            safety.
          </p>

          <br />

          <p>
            To ensure you receive authentic and high-quality Ayurveda products,
            please make your purchases exclusively from our official website:{" "}
            <strong className="line">www.example.com</strong>
          </p>

          <br />

          <p>
            By buying directly from us, you can rest assured that you are
            getting genuine products, manufactured with care and precision.
          </p>

          <br />

          <p>
            Thank you for trusting us to be a part of your wellness. Your
            health, happiness, and satisfaction are our top priorities!
          </p>
        </div>
      </div>
    </div>
  );
}

export default Authenticity;
